// React components
import { useState } from "react";

// @mui material components
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import breakpoints from "assets/theme-dark/base/breakpoints";

// Material Dashboard 2 PRO React TS components
import Sideform from "examples/Sideform";

// Country form components
import CountryForm from "./components/CountryForm";
import MainContent from "./components/MainContent";
import Export1CountryForm from "./components/Export1CountryForm";
import ExportXCountriesForm from "./components/ExportXCountriesForm";

// Contexts
import FormAnalyticsContextProvider, {
  useFormAnalyticsContext,
} from "contexts/contextFormAnalytics";
import { useUserContext } from "contexts/contextUser";

function Analytics(): JSX.Element {
  return (
    <FormAnalyticsContextProvider>
      <MainContent />
      <AnalyticsSideform />
    </FormAnalyticsContextProvider>
  );
}

function AnalyticsSideform(): JSX.Element {
  const { isAuthenticated } = useUserContext();
  const { isLoading, isError } = useFormAnalyticsContext();

  const [tabValue, setTabValue] = useState<number>(0);
  const handleSetTabValue = (event: any, newValue: number) => setTabValue(newValue);
  const isViewTab = tabValue === 0;
  const isExportTab = tabValue === 1;
  const showAppBar = isAuthenticated && !isLoading && !isError;

  return (
    <Sideform title="Data Manipulation" color="info">
      {showAppBar && (
        <AppBar position="relative" sx={{ marginBottom: 2 }}>
          <Tabs
            orientation={window.innerWidth < breakpoints.values.md ? "vertical" : "horizontal"}
            value={tabValue}
            onChange={handleSetTabValue}
          >
            <Tab label="View" />
            <Tab label="Export" />
          </Tabs>
        </AppBar>
      )}

      {isViewTab && <CountryForm />}
      {isExportTab && isAuthenticated && (
        <>
          <ExportXCountriesForm />
          <Export1CountryForm />
        </>
      )}
    </Sideform>
  );
}

export default Analytics;
